import React from "react";
import Text from "../typography/Text";

export default ({ options = [], value, setValue = () => {}, ...modifiers }) => {
  let className = "toggle";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return (
    <div className={className}>
      {options.map((option, index) => (
        <div
          className={`toggle_option ${value === option.value ? "-active" : ""}`}
          onClick={() => setValue(option.value)}
          key={index}
        >
          <Text small>{option.label}</Text>
        </div>
      ))}
    </div>
  );
};
